import { PiPaperPlaneTiltLight } from 'react-icons/pi'
import { IconButton } from '~/components/ui/atoms/icon-button/IconButton'

interface CommentFieldIconWidgetProps {
  isEmpty: boolean
  handleCommentSubmit: () => void
}

export function CommentFieldIconWidget({
  isEmpty,
  handleCommentSubmit,
}: CommentFieldIconWidgetProps) {
  return (
    <IconButton
      disabled={isEmpty}
      onClick={() => {
        handleCommentSubmit()
      }}
      size="small"
      variant="true-ghost"
    >
      <PiPaperPlaneTiltLight />
    </IconButton>
  )
}
